(function () {
  function init() {
    var section = document.querySelector('.hero-custom');
    if (!section) return;

    function revealContent() { section.classList.remove('hero-js-init'); }

    // GSAP missing (CDN failed) → just show everything, no animation.
    if (typeof window.gsap === 'undefined') { revealContent(); return; }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ── Content + benefit cards: rise from below with a tiny stagger ──
    var contentEls = [
      section.querySelector('.hero-custom__logo'),
      section.querySelector('.hero-custom__heading'),
      section.querySelector('.hero-custom__divider'),
      section.querySelector('.hero-custom__text'),
      section.querySelector('.hero-custom__buttons')
    ].filter(Boolean);
    var benefits = Array.prototype.slice.call(section.querySelectorAll('.hero-custom__benefit'));

    if (reduce) {
      revealContent();
    } else {
      if (contentEls.length) gsap.set(contentEls, { autoAlpha: 0, y: 70 });
      if (benefits.length) gsap.set(benefits, { autoAlpha: 0, y: 70 });
      revealContent(); // gsap inline styles now control visibility (no flash)
      if (contentEls.length) {
        gsap.to(contentEls, { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.1, ease: 'power2.out' });
      }
      if (benefits.length) {
        gsap.to(benefits, { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.1, ease: 'power2.out', delay: 0.25 });
      }
    }

    var leftTop = document.querySelector('.hero-custom__side-img--left_top');
    var rightTop = document.querySelector('.hero-custom__side-img--right_top');
    var rightMid = document.querySelector('.hero-custom__side-img--right_mid');
    var leftMid = document.querySelector('.hero-custom__side-img--left_mid');
    var leftBot = document.querySelector('.hero-custom__side-img--left_bot');
    var rightExtra = document.querySelector('.hero-custom__side-img--right_extra');
    var rightBot = document.querySelector('.hero-custom__side-img--right_bot');

    // Side images entrance. gsap.from animates TO each element's current
    // computed transform, so any CSS rotate() used as the resting state is
    // preserved. Rotation during the entrance runs ONLY on desktop; on
    // tablet/mobile the images just move (x/y) — cheaper on mobile GPUs.
    var mm = gsap.matchMedia();

    function runSideAnims(withRotation) {
      function anim(el, x, y, rotation) {
        if (!el) return;
        var cfg = { x: x, y: y, duration: 0.8, ease: 'power2.out' };
        if (withRotation && rotation != null) {
          cfg.rotation = rotation;
          cfg.transformOrigin = '50% 50%';
        }
        gsap.from(el, cfg);
      }

      anim(leftTop, -150, 200, 200);
      anim(rightTop, 450, -150, 280);
      anim(rightMid, 0, 250, 200);
      anim(leftMid, -200, 250, null);    // never rotated
      anim(leftBot, 150, 180, 200);
      anim(rightExtra, 200, 250, null);  // never rotated
      anim(rightBot, 200, 250, 200);
    }

    // Desktop: move + rotate
    mm.add('(prefers-reduced-motion: no-preference) and (min-width: 1024px)', function () {
      runSideAnims(true);
    });

    // Tablet & mobile: move only, no rotation
    mm.add('(prefers-reduced-motion: no-preference) and (max-width: 1023px)', function () {
      runSideAnims(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
